import Vue from "vue";
import Vuex from "vuex";
import io from "socket.io-client";

Vue.use(Vuex);


const BASE_URL = (window.ENV && window.ENV.VUE_APP_BASE_URL)  || process.env.VUE_APP_BASE_URL || "ERROR";

const SERVER_URL = (window.ENV && window.ENV.VUE_APP_SERVER_URL)  || process.env.VUE_APP_SERVER_URL || "ERROR";


export default new Vuex.Store({
  state: {
    BASE_URL,
    username: null,
    socket: io(SERVER_URL, {
      transports: ["polling", "websocket"],
      upgrade: true,
      closeOnBeforeunload: false,
    }),
  },
});
